import {createSelector} from "reselect";
import {selectCart} from "../cart/selectors";

export const selectWishlist = createSelector(state => state, state => state.get('wishlist'));

export const selectWishlistCount = createSelector(selectWishlist, selectCart, (wishlist, cart) => cart.get('wishlistCount') || 0);

export const makeIsProductAddedToWishlistSelector = () => createSelector(selectWishlist, (_, props) => props.productId, (wishlist, productId) => !!wishlist.find((product) => product.get('ProductId') === productId));
